export default {
  setConsorcios({ commit }, payload) {
    commit("setConsorcios", payload)
  }
}
